<template>
  <v-container fluid class="pa-0">
    <v-layout align-start>
      <v-flex>
        <v-row no-gutters justify="center" class="mt-n4">
                <span style="font-size: 34px; color: #616161"><v-icon large
                    class=" pb-2">mdi-cash-register</v-icon>Cajas</span>
              </v-row>
              <v-row align="center" justify="center" class="mt-n4">
                  <v-col cols="3">
                    <v-autocomplete dense outlined v-model="business_selected" :items="bussines_units"
                      @input="update_filter()" @change="setLocation" label="Unidad de negocio" color="cyanText"
                      prepend-inner-icon="corporate_fare" required hide-details></v-autocomplete>
                  </v-col>
                  <v-col cols="3">
                    <v-autocomplete hide-details dense outlined v-model="location_selected" return-object
                      :items="locationsFrombusiness" @input="update_filter()" color="cyanText" label="Location"
                      prepend-inner-icon="my_location" required>
                      <template v-slot:no-data>
                        <div class="px-4">Seleciona la unidad de negocio</div>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                    <v-menu v-model="menu_start_date" :close-on-content-click="false" :nudge-right="10"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field hide-details dense outlined v-model="dateFormatDMY" label="Desde"
                          prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="filters.start_date" @input="
                        get_boxes_to_accounting(), (menu_start_date = false)
                        "></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="2">
                    <v-menu v-model="menu_end_date" :close-on-content-click="false" :nudge-right="40"
                      transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field hide-details dense outlined v-model="date2FormatDMY" label="Hasta"
                          prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="filters.end_date" @input="
                        get_boxes_to_accounting(), (menu_end_date = false)
                        "></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
        <v-tabs-items v-model="tab">
          <v-tab-item :value="1">
            <v-card flat>
            
              <v-card-text class="py-0">
            
                <v-card outlined class="mt-2 pt-2">
                  <v-card-text class="pa-0">
                    <v-data-table :headers="headers" :loading="loading_boxes" :search="search" height="50vh"
                      loading-text="Cargando cajas..." :items="boxes_filtered" :items-per-page="60">
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-toolbar-title>Cajas</v-toolbar-title>
                          <v-divider class="mx-4" inset vertical></v-divider>
                          <span>{{ boxes_entries.length }}</span>
                          <v-spacer></v-spacer>
                          <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Buscar"
                            single-line outlined hide-details dense>
                          </v-text-field>
                          <v-spacer></v-spacer>
                          <v-divider class="mx-3" inset vertical></v-divider>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon @click="show_box_details(item)" color="primary">mdi-page-next-outline</v-icon>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="2">
            <v-container fluid>
              <v-row align="center">
                <v-col cols="4" align="start">
                  <v-btn dense color="error" outlined small @click="tab = 1"> Volver </v-btn>
                </v-col>
                <v-col cols="4" align="center">
                  <span style="font-size: 24px; color: #616161"><v-icon large
                      class="pr-1 pb-2">mdi-cash-register</v-icon>{{ box_selected.box }}</span>
                </v-col>

                <v-col cols="4" align="end">
                  <v-btn dense color="success" outlined small @click="save()" :disabled="payments_selected.length==0"> Continuar </v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters justify="center">
                <span style="font-size: 14px; color: #616161">Turno: {{ box_selected.id }} - {{ box_selected.user
                }}</span>
              </v-row>
              <v-row align="center" justify="center" class="mb-2">
                <v-col cols="3">
                  <v-autocomplete v-model="payment_filter.currency" :items="box_selected.currencies" item-text="currency"
                    item-value="currency_id" color="cyanText" return-object label="Moneda" outlined dense
                    hide-details></v-autocomplete>
                </v-col>
                <v-col cols="1" align="center">
                  <v-icon>arrow_forward</v-icon>
                </v-col>
                <v-col cols="3" justify="center">
                  <v-autocomplete v-model="payment_filter.account_id" :items="accounts" item-text="name" item-value="id"
                    label="Enviar a la cuenta" outlined dense hide-details></v-autocomplete>
                </v-col>
              </v-row>
              <v-card outlined>
                <v-data-table :headers="headers_payments" :items="payments_filtered" :search="search_payment"
                  v-model="payments_selected" :single-select="singleSelect" :loading="loading_payments"
                  item-key="invoice_payment_id" selectable-key="selectable" :items-per-page="60" show-select fixed-header
                  height="43vh" dense loading-text="Cargando facturas..." checkbox-color="primary" :footer-props="{
                    itemsPerPageText: 'Elementos por página:',
                    'items-per-page-text': footerText,
                    'page-text': '{0}-{1} de {2}',
                    'select-all-text': 'Seleccionar todo',
                    'pagination-text': 'Registros'
                  }">
                  <template v-slot:top>
                    <v-toolbar flat id="toolbar">
                      <span>Seleccionadas {{ payments_selected.length }}</span>
                      <v-spacer></v-spacer>
                      <v-text-field class="text-xs-center" v-model="search_payment" append-icon="search" label="Buscar"
                        single-line dense hide-details outlined>
                      </v-text-field>
                      <v-spacer></v-spacer>
                      <v-btn medium dark title="Filtrar" color="primary" text @click="select_all_payment()">Seleccionar
                        todo
                        <v-icon medium> add </v-icon>
                      </v-btn>
                      <v-divider class="mx-2" inset vertical></v-divider>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon color="light-blue" class="mr-2" @click="payments_selected = []" v-bind="attrs"
                            v-on="on">
                            cleaning_services</v-icon>
                        </template>
                        <span>Limpiar lista</span>
                      </v-tooltip>
                    </v-toolbar>
                  </template>
                  <template v-slot:[`item.invoice_number`]="{ item }">
                    <v-hover v-slot="{ hover }">
                      <span @click="viewOrigin(item.invoice_number)"
                        class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                          color: hover ? 'red' : 'black',
                          cursor: hover ? 'pointer' : '',
                          'text-decoration': hover ? 'underline' : '',
                        }">
                        {{ item.invoice_number }}</span>
                    </v-hover>
                  </template>
                  <template v-slot:[`item.recorded`]="{ item }">
                    <v-chip small :color="invoice_recorder_type(item.status_recorder).color" dark>
                      {{ invoice_recorder_type(item.status_recorder).text }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-card>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from "moment";
export default {
  data: () => ({
    loading_boxes: false,
    loading_payments: false,
    search: null,
    search_payment: null,
    tab: 1,
    bussines_units: [],
    accounts: [],
    filters: {
      business: null,
      location: null,
      start_date: null,
      end_date: null,
    },
    payment_filter: {
      currency: null,
      account_id: null,
    },
    boxes_entries: [],
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
      },
      { text: "ID Caja", value: "box_id" },
      { text: "Location", value: "location" },
      { text: "Caja", value: "box" },
      { text: "Apertura", value: "open_at" },
      { text: "Cierre", value: "close_at" },
      { text: "Estatus", value: "status" },
      { text: "", value: "actions", sortable: false },
    ],
    box_selected: { box: "" },
    payments: [],
    payments_selected: [],
    singleSelect: false,
    headers_payments: [
      {
        text: "Codigo",
        align: "start",
        value: "invoice_payment_id",
      },
      {
        text: "Factura",
        align: "start",
        value: "invoice_number",
      },
      { text: "Estatus", value: "recorded", align: "center" },
      { text: "Cliente", value: "entity_name", align: "center" },
      { text: "Fecha", value: "emission_date", align: "center" },
      { text: "Moneda", value: "currency_code", align: "center" },
      { text: "Monto", value: "amount_formated", align: "end" },
    ],
    menu_start_date: false,
    menu_end_date: false,
  }),
  computed: {
    business_selected: {
      get() {
        return this.$store.state.app.filters.business;
      },
      set(value) {
        this.$store.commit("setBusiness", value);
      },
    },
    location_selected: {
      get() {
        return this.$store.state.app.filters.location;
      },
      set(value) {
        this.$store.commit("setLocation", value);
      },
    },
    locationsFrombusiness() {
      let locations = Object.assign(
        [],
        this.$store.state.auth.locations.filter(
          (element) => element.bus_id == this.filters.business
        )
      );
      if (locations.length > 1) {
        locations.unshift({ id: 0, value: 0, text: "Todos" });
      }
      //    this.filters.location = locations[0].id;
      return locations;
    },
    boxes_filtered() {
      let boxes = this.boxes_entries.filter(
        (element) => element.business_unit_id == this.filters.business
      );
      if (this.filters.location && this.filters.location > 0) {
        boxes = boxes.filter(
          (element) => element.location_id == this.filters.location
        );
      }
      return boxes;
    },
    payments_filtered() {
      let payments = this.payments.filter(
        (element) =>
          element.currency_id == this.payment_filter.currency.currency_id
      );
      let set_payments = [];
      for (let item of payments) {
          let new_invoice_payment = Object.assign({},item);
          new_invoice_payment.amount_formated = this.currencyFormat(parseFloat(item.payment_amount));
          set_payments.push(new_invoice_payment)
      }
      return set_payments;
    },
    footerText() {
      let contabilizadas = this.payments_filtered.filter((element) => element.status_recorder == 1);
      let sin_contabilizar = this.payments_filtered.filter((element) => element.status_recorder == 2);
      return `Total: ${this.payments_filtered.length}  |  Contabilizadas: ${contabilizadas.length}  |  Sin contabilizar: ${sin_contabilizar.length} |  Parcial: ${this.payments_filtered.length - contabilizadas.length - sin_contabilizar.length}`;
    },
    dateFormatDMY() {
      return moment(this.filters.start_date).format("DD/MM/YYYY");
    },
    date2FormatDMY() {
      return moment(this.filters.end_date).format("DD/MM/YYYY");
    },
  },
  created() { },
  mounted() {
    this.initialized();
  },
  watch: {},
  methods: {
    async initialized() {
      this.bussines_units = Object.assign(
        [],
        this.$store.state.auth.bussines_units
      );
      this.filters.start_date = moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.filters.end_date = moment().format("YYYY-MM-DD");
      this.get_boxes_to_accounting();
      //CUENTAS
      const resultTypeAccounts = await this.api_Get("accounting/accountsUsable");
      this.accounts = await resultTypeAccounts.json();
    },
    setLocation() {
      if (this.business_selected != 0 || this.business_selected != null) {
        if (this.locationsFrombusiness.length > 0) {
          this.filters.location = this.locationsFrombusiness[0].id;
        }
      } else {
        this.filters.location = null;
      }
    },
    async get_boxes_to_accounting() {
      this.loading_boxes = true;
      const request = await this.api_Post("income/boxes_to_accounting", {
        start_date: this.filters.start_date,
        end_date: this.filters.end_date,
      });
      this.boxes_entries = await request.json();
      for (let key in this.boxes_entries) {
        this.boxes_entries[key].open_at = moment(
          this.boxes_entries[key].open_at
        ).format("DD/MM/YYYY HH:mm");
        this.boxes_entries[key].close_at = this.boxes_entries[key].close_at
          ? moment(this.boxes_entries[key].close_at).format("DD/MM/YYYY HH:mm")
          : "-";
      }
      this.loading_boxes = false;
    },
    async show_box_details(item) {
      this.loading_payments = true;
      this.box_selected = item;
      this.tab = 2;
      const invoices_request = await this.api_Post("income/get_moved_payment_details", {
        box_entry_id: item.id,
      });
      this.payments = await invoices_request.json();
      for (let key in this.payments) {
        this.payments[key].emission_date = moment(
          this.payments[key].emission_date
        ).format("DD/MM/YYYY HH:mm");
      }
      this.payment_filter.currency = item.currencies[0];
      this.payment_filter.account_id = this.accounts[0].id;
      this.loading_payments = false;
    },
    update_filter() {
      this.filters.business = this.business_selected;
      this.filters.location = this.location_selected.id;
      this.get_boxes_to_accounting();
    },
    viewOrigin(code) {
      this.showInvoice(code,true)
    
    },
    invoice_recorder_type(status_recorder) {
      let status = [
        { text: "Parcial", color: "warning" },
        { text: "Contabilizada", color: "success" },
        { text: "Sin contabilizar", color: "error" },
      ];
      return status[status_recorder];
    },
    select_all_payment() {
      this.payments_selected = this.payments_filtered.filter(
        (element) => element.selectable == true
      );
    },
    async save() {
      try {
        this.loading = true; 
        let in_payments = [];
        for(let item of this.payments_selected){
          in_payments.push({
            payment_id: item.invoice_payment_id,
            chart_of_account_id: this.payment_filter.account_id
          })
        }
          
        const request = await this.api_Post("accounting/move_payment_char_of_account", {
          user_id: this.$store.state.auth.user.user.user_id,
          business_unit_id: this.filters.business,
          in_payments: in_payments
        })
        if(request.status == 200){
          this.$toast.success("Cuentas contables guardadas");
          this.tab = 1;
          this.get_boxes_to_accounting();
          
        }
      } catch (error) {
        this.$toast.error(error.message);
      }
      this.loading = false; 
    }
  },
};
</script>
  